export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00730.35e67ff6.png";